import { render, staticRenderFns } from "./liabilityHomePage.vue?vue&type=template&id=a3fe28a2&"
import script from "./liabilityHomePage.vue?vue&type=script&lang=js&"
export * from "./liabilityHomePage.vue?vue&type=script&lang=js&"
import style0 from "./liabilityHomePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3fe28a2')) {
      api.createRecord('a3fe28a2', component.options)
    } else {
      api.reload('a3fe28a2', component.options)
    }
    module.hot.accept("./liabilityHomePage.vue?vue&type=template&id=a3fe28a2&", function () {
      api.rerender('a3fe28a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Insurance/components/liabilityHomePage.vue"
export default component.exports